import { Component, Input, OnInit } from '@angular/core';
import { BeautyBookPost } from '@features/beautybook/interfaces/beautybook.interface';
import {
  faArrowLeft,
  faBars,
  faComment,
  faHeart,
  faShare,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'fc-beautybook-item',
  templateUrl: './beautybook-item.component.html',
  styleUrls: ['./beautybook-item.component.css'],
})
export class BeautybookItemComponent implements OnInit {
  faHeart = faHeart;
  faComment = faComment;
  faShare = faShare;

  @Input() post: BeautyBookPost = {} as BeautyBookPost;
  constructor() {}

  ngOnInit(): void {}
}
